export const ReplyIcon = ({
  width = '20',
  height = '20',
  stroke = '#000000'
}) => (
  <svg
    viewBox="0 0 24 24"
    height={height}
    width={width}
    fill="none"
    stroke={stroke}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <g strokeWidth="0" />
    <g
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g>
      <polyline points="9 17 4 12 9 7" />
      <path d="M20 18v-2a4 4 0 00-4-4H4" />
    </g>
  </svg>
)
